import { format, isToday, isTomorrow, isValid } from 'date-fns';

const dateFormat = {
  extraLong: 'h:mmaaa d MMMM yyyy' /* e.g "10:44am 9 October 2024" */,
  long: 'h:mmaaa d MMM' /* e.g "10:44am 9 Oct" */,
  short: 'd MMM yy' /* e.g 17 Aug 23 */,
  friendly: 'cccc d MMM' /* e.g "Friday 17 Aug" */,
  extraFriendly: 'cccc d MMMM' /* e.g "Friday 17th August" */,
};

export const getTimeWindow = (dateTime: string | null, windowType: 'days' | 'hours' = 'hours', windowSize = 2) => {
  if (!dateTime) return 'TBC';
  const etaDate = new Date(dateTime);
  const offsetEtaDate = new Date(dateTime);

  const getWindowDay = (date: Date, formatType: string) => {
    if (isToday(date)) return 'Today';
    if (isTomorrow(date)) return 'Tomorrow';
    return format(date, dateFormat[formatType]);
  };

  if (windowType === 'days') {
    offsetEtaDate.setDate(etaDate.getDate() + windowSize);
  } else if (windowType === 'hours') {
    offsetEtaDate.setTime(etaDate.getTime() + windowSize * 60 * 60 * 1000);
  }
  return windowType === 'days'
    ? `${format(etaDate, dateFormat['short'])} – ${format(
        offsetEtaDate,
        dateFormat['short']
      )}` /* 19 Jan 24 – 21 Jan 24 */
    : `${getWindowDay(etaDate, 'friendly')} ${format(etaDate, 'h:mmaaa')} – ${format(
        offsetEtaDate,
        'h:mmaaa'
      )}`; /* Friday 19 Jan 12:00PM – 2:00PM */
};

export const getFriendlyFormattedDate = (
  dateTime: string | null,
  type: 'extraLong' | 'long' | 'short' | 'friendly' | 'extraFriendly' = 'friendly',
  shouldIncludeTimeStamp = false
) => {
  if (!dateTime) return 'TBC';
  const etaDate = new Date(dateTime);
  if (!isValid(etaDate)) return 'TBC';
  if (isToday(etaDate)) {
    return shouldIncludeTimeStamp ? `${format(etaDate, 'h:mmaaa')} today` : 'Today'; /* e.g. "4:59pm today" */
  }
  if (isTomorrow(etaDate)) {
    return shouldIncludeTimeStamp ? `${format(etaDate, 'h:mmaaa')} tomorrow` : 'Tomorrow'; /* e.g. "Tomorrow */
  }
  return format(etaDate, dateFormat[type]);
};
